import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {

    // Decides if the route should be stored
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    /*Store the information for the route we're destructing*/
    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    }

    /*Return true if we have a stored route object for the next route*/
    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    /*If we returned true in shouldAttach(), now return the actual route data for restoration*/
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        return null;
    }

    /*Reuse the route if we're going to and from the same route*/
    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return false;
    }
}
